import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LoginPage as OmnitokLoginPage } from '@omnitok/ui';
import { useAuth } from '@/features/auth/hooks/useAuth';

const DEFAULT_LOGIN_ERROR = 'No fue posible iniciar sesión';

function getLoginErrorMessage(error: unknown): string {
  const failure = error as {
    message?: string;
    response?: { data?: { error?: { message?: string } } };
  };

  return failure.response?.data?.error?.message ?? failure.message ?? DEFAULT_LOGIN_ERROR;
}

export default function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { login, isLoading } = useAuth();
  const [error, setError] = useState('');

  const handleLoginSubmit = (email: string, password: string) => {
    setError('');

    const query = new URLSearchParams(location.search);
    query.delete('handoff');
    const suffix = query.toString();

    void login({ email, password })
      .then(() => navigate(`/localization${suffix ? `?${suffix}` : ''}`))
      .catch((loginError: unknown) => setError(getLoginErrorMessage(loginError)));
  };

  return (
    <OmnitokLoginPage
      language="es"
      variant="split"
      logo={
        <span className="app-login-brand app-login-brand--compact" aria-label="Omnitok">
          O
        </span>
      }
      logoWide={
        <span className="app-login-brand">
          <span className="app-login-brand__name">Omnitok</span>
          <span className="app-login-brand__product">Content Translate</span>
        </span>
      }
      splitLogo={
        <span className="app-login-brand app-login-brand--inverse">
          <span className="app-login-brand__name">Omnitok</span>
          <span className="app-login-brand__product">Content Translate</span>
        </span>
      }
      onLoginSubmit={handleLoginSubmit}
      loading={isLoading}
      error={error}
      showRememberMe={false}
      showForgotPassword={false}
      footer={<span className="app-login-footer">Acceso seguro para el equipo de contenidos</span>}
    />
  );
}
